import React from "react";
import { connect } from "react-redux";

const mapDispatchToProps = dispatch => {
  return { dispatch };
};

function withUnmountAction(action) {
  return function(Component) {
    class Enhancer extends React.Component {
      componentWillUnmount() {
        this.props.dispatch(action);
      }

      render() {
        const { dispatch, ...rest } = this.props;
        return <Component {...rest} />;
      }
    }

    Enhancer.displayName = `withUnmountAction(${Component.displayName ||
      Component.name})`;

    return connect(
      null,
      mapDispatchToProps
    )(Enhancer);
  };
}

export default withUnmountAction;
